export enum DyId {
  Title = 'dy-title',
  NavWidgets = 'dy-nav-widgets',
}
